import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

export const removeLoginUserAccess_Api_Call = createAsyncThunk(
  "remove/access/login/devices/access",
  async (documentId, thunkApi) => {
    try {
      const END_POINT_REMOVE_LOGIN_ACCESS_DEVICES = `${
        process.env.REACT_APP_ADMIN_USERS
      }/${documentId}${process.env.REACT_APP_END_POINT_ADMIN_LOGOUT_DEVICE_PATH.replace(
        /"/g,
        ""
      )}`;

      const result = fetchInterceptors(
        END_POINT_REMOVE_LOGIN_ACCESS_DEVICES,
        "DELETE"
      );

      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const removeLoginUserAccess_Slice = createSlice({
  name: "removeLoginUserAccess",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_RemoveLoginUserAccess: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(removeLoginUserAccess_Api_Call.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeLoginUserAccess_Api_Call.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(removeLoginUserAccess_Api_Call.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_RemoveLoginUserAccess } =
  removeLoginUserAccess_Slice.actions;

export default removeLoginUserAccess_Slice.reducer;
